/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import axios from 'axios'
import Cookie from 'js-cookie'
import jwtDecode from 'jwt-decode'
import PropTypes from 'prop-types'

import { CLAIM_EMAIL, CLAIM_NAME, CLAIM_ROLE, CLAIM_USERID } from 'constants/claimsConstants'
import {
  COOKIE_ACCESS_TOKEN_NAME,
  COOKIE_NAME_ISLOGEDIN,
  COOKIE_NAME_USER,
  COOKIE_ROLE_NAME,
  COOKIE_ACCESS_SHOPIFY,
} from 'constants/cookiesConsts'
import { routeBase } from 'constants/environments.constants'
import { SUPER_ADMIN, CUSTOMER_SUPPORT } from 'constants/rolesConst'
import { routesLink } from 'constants/routesConsts'
import { FEATURES_FLAGS } from 'constants/urls'
import { getReturnsCount } from 'services/Returns'
import { encryptAES256CBC } from 'utils/encryptData'
import { findRole } from 'utils/functions'
import { FEATURE_FLAG_RECHARGABLE_PRODUCT_SELLER_IDS } from 'constants/appConstants'

const AuthContext = React.createContext()
export default AuthContext

export const AuthContextProvider = ({ children, clientIpAddress, hubspotTicketUrl }) => {
  const [user, setUser] = useState(null)
  const [categorylocal, setCategorylocal] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(null)
  const [needAddWareHouse, setNeedAddWareHouse] = useState(false)
  const [isShopify, setIsShopify] = useState(false)
  const [currentFilterOrders, setCurrentFilterOrders] = useState('Procesando')
  const [returnsCount, setReturnsCount] = useState(0)
  const [rechargableProductSellerIds, setRechargableProductSellerIds] = useState([])
  const [dialogAlert, setDialogAlert] = useState({
    open: false,
    title: '',
    handleClose: null,
    message: '',
    personalized: false,
    textButtonConfirm: '',
    actionConfirm: null,
    actionCancel: null,
    textButtonCancel: '',
    children: null,
    successful: false,
  })
  const [clientIp, setClientIp] = useState(clientIpAddress)

  const persistUserData = (userData) => {
    Cookie.set(COOKIE_NAME_ISLOGEDIN, true)
    Cookie.set(COOKIE_NAME_USER, userData)
  }

  const updateReturnsCount = () => {
    const isAdmin = [SUPER_ADMIN, CUSTOMER_SUPPORT].includes(user.role)
    if (routeBase[process.env.REACT_APP_ENVIRONMENT].hideReturns || !isAdmin) {
      setReturnsCount(0)
    } else {
      getReturnsCount()
        .then((response) => {
          setReturnsCount(response.data)
        })
        .catch((error) => {
          setReturnsCount(0)
          console.error('Error al obtener el conteo de devoluciones:', error)
          throw error
        })
    }
  }

  const fetchRechargableProductSellerIds = async () => {
    try {
      const response = await axios.get(`${FEATURES_FLAGS}`, {
        headers: {
          'X-Client-Token': encryptAES256CBC(clientIpAddress),
        },
      })
      const rechargableConfig = response.data.find(
        (data) => data.name === FEATURE_FLAG_RECHARGABLE_PRODUCT_SELLER_IDS
      )
      const idsArray =
        rechargableConfig?.value
          ?.split(',')
          .map((id) => id.trim())
          .filter((id) => id && !isNaN(id)) ?? []

      setRechargableProductSellerIds(idsArray)
    } catch (error) {
      console.error('Error al obtener RechargableProductSellerIds:', error)
      setRechargableProductSellerIds([])
    }
  }

  const persistShopifyData = (isShopify) => {
    Cookie.set(COOKIE_ACCESS_SHOPIFY, isShopify)
  }

  const recoverUserData = () => {
    const cookieUser = Cookie.getJSON(COOKIE_NAME_USER)

    return cookieUser
      ? {
          id: cookieUser.id || '',
          name: cookieUser.name || '',
          sellerId: cookieUser.sellerId || '',
          sellerName: cookieUser.sellerName || '',
          email: cookieUser.email || '',
          picture: cookieUser.picture || null,
          role: cookieUser.role || null,
          passwordAlreadyChanged: cookieUser.passwordAlreadyChanged || null,
          isHadWarehouse: cookieUser.isHadWarehouse || null,
          isHadTermsAndConditions: cookieUser.isHadTermsAndConditions || null,
        }
      : null
  }

  const setLoggedin = (userLoggedin) => {
    persistUserData(userLoggedin)
    setUser(userLoggedin)
    setIsLoggedIn(true)
  }

  const setAccessToken = (accessToken) => {
    const decoded = jwtDecode(accessToken)
    let role = ''
    let scopes = []
    if (Array.isArray(decoded[CLAIM_ROLE])) {
      role = findRole(decoded[CLAIM_ROLE])
      scopes = decoded[CLAIM_ROLE]
    } else {
      role = decoded[CLAIM_ROLE]
      scopes = [decoded[CLAIM_ROLE]]
    }
    const userInfo = {
      id: decoded[CLAIM_USERID],
      firstName: decoded[CLAIM_NAME],
      name: decoded.UserName,
      email: decoded[CLAIM_EMAIL],
      role: role,
      sellerId: decoded.SellerId,
      sellerName: decoded.SellerName,
      picture: decoded.Logo ? decoded.Logo : null,
      passwordAlreadyChanged: decoded.PasswordAlreadyChanged,
      isHadWarehouse: decoded.IsHadWarehouse,
      isHadTermsAndConditions: decoded.IsHadTermsAndConditions,
      scopes,
    }
    setLoggedin(userInfo)
    Cookie.set(COOKIE_ACCESS_TOKEN_NAME, accessToken)
    Cookie.set(COOKIE_ROLE_NAME, role)
  }
  const getAccessisShopify = () => {
    return Cookie.get(COOKIE_ACCESS_SHOPIFY)
  }

  const getAccessToken = () => {
    return Cookie.get(COOKIE_ACCESS_TOKEN_NAME)
  }

  const logout = (loginUser = null) => {
    localStorage.removeItem('lastModalShownAt')
    Cookie.remove(COOKIE_ACCESS_TOKEN_NAME)
    Cookie.remove(COOKIE_NAME_ISLOGEDIN)
    Cookie.remove(COOKIE_NAME_USER)
    Cookie.remove(COOKIE_ACCESS_SHOPIFY)
    if (loginUser !== 'login') {
      window.location = routesLink.login
    }
  }
  const getRoleName = () => {
    return Cookie.get(COOKIE_ROLE_NAME)
  }

  const updateCategoryLocal = (categoryBool) => {
    setCategorylocal(categoryBool)
  }

  useEffect(() => {
    const userData = recoverUserData()
    if (userData) {
      setUser(userData)
      setIsLoggedIn(true)
    } else {
      setIsLoggedIn(false)
    }
  }, [])

  // use effect when Cookie.get(COOKIE_ACCESS_TOKEN_NAME) change
  useEffect(() => {
    const accessToken = getAccessToken()
    if (isLoggedIn && accessToken) {
      setAccessToken(accessToken)
      updateReturnsCount()
      fetchRechargableProductSellerIds()
    }
  }, [isLoggedIn])

  useEffect(() => {
    setClientIp(clientIpAddress)
  }, [clientIpAddress])

  return (
    <AuthContext.Provider
      value={{
        setLoggedin,
        setAccessToken,
        categorylocal,
        getAccessToken,
        getRoleName,
        userLoggedin: user,
        isLoggedIn,
        logout,
        isShopify,
        updateCategoryLocal,
        currentFilterOrders,
        setCurrentFilterOrders,
        dialogAlert,
        setDialogAlert,
        needAddWareHouse,
        setNeedAddWareHouse,
        setIsShopify,
        persistShopifyData,
        getAccessisShopify,
        returnsCount,
        updateReturnsCount,
        clientIp,
        hubspotTicketUrl,
        rechargableProductSellerIds,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const AuthContextConsumer = AuthContext.Consumer
